import { lineSubscriptionEvent } from '@dni-analysis'
import { Text } from '@pets-ui/Text/Text'
import { VStack } from '@pets-ui/VStack/VStack'
import { useTranslation } from 'react-i18next'
import { useLineSubscription } from '../../../hooks/useLineSubscription'
import { getCurrentPageUrl } from '../../../utils/location'
import { ButtonSubscribeLine } from './ButtonSubscribeLine'
import { useContextMyAccountDialog } from './Provider/useContextMyAccountDialog'

interface LineSubscribeProps {
  isSubscribed: boolean
  /**
   * 這個 flag 只涵蓋請求進行中的情況：請求失敗時呼叫端拿不到 profile，按鈕仍會落回可點擊的「未訂閱」，是刻意接受的行為。
   */
  isSubscriptionStatusLoading: boolean
}

export function LineSubscribe(props: LineSubscribeProps) {
  const { t } = useTranslation()
  const { isSubscribed, isSubscriptionStatusLoading } = props
  const { showDialogServerError } = useContextMyAccountDialog()
  const { subscribeToLine, isLoading: isRedirectingToLine } = useLineSubscription()

  const { sendClickLineSubscriptionEvent } = lineSubscriptionEvent()

  const handleClickLineSubscribe = async () => {
    if (!isSubscribed) sendClickLineSubscriptionEvent()
    await subscribeToLine(getCurrentPageUrl(), !isSubscribed, {
      onError: showDialogServerError,
    })
  }

  return (
    <VStack gap={3}>
      <Text variant="h4">{t('login.orderNotifications')}</Text>
      <ButtonSubscribeLine
        loading={isRedirectingToLine || isSubscriptionStatusLoading}
        isSubscribed={isSubscribed}
        onClick={handleClickLineSubscribe}
      />
      <Text color="gray" variant="caption">{t('login.scbscribedLineContext')}</Text>
    </VStack>
  )
}
